import * as PIXI from 'pixi.js';
import Appearance from '.';
import AssetManager from '../../../Base/AssetManager';
import Global from '../../../Global';
import { Shape } from '..';

export default class Text extends Appearance {
    constructor(gsoParent) {
        super(gsoParent);

        this.text = 'Tekst';

        this.pixiContainer = null;
        this.pixiText = null;

        this.color = 0xffffff;
        this.size = 24;
    }

    createCircleMask() {
        this.circleMaskGraphics = new PIXI.Graphics();
        this.circleMaskGraphics.beginFill(0x000000);
        this.circleMaskGraphics.drawCircle(0, 0, (Global.NATIVE_BLOCK_SIZE * this.state.blok.size.x) / 2);
        this.circleMaskGraphics.endFill();

        this.pixiContainer.mask = this.circleMaskGraphics;
        this.pixiContainer.addChild(this.circleMaskGraphics);
    }

    onCreateVisuals() {
        const scale = 2;

        this.pixiContainer = new PIXI.Container();

        let ySize = this.state.blok.size.y;
        if (this.state.blok.shape === Shape.circle) ySize = this.state.blok.size.x;

        this.pixiText = new PIXI.Text(this.text, {
            fontFamily: 'font_retro_gaming,Arial',
            fontSize: this.size * 2,
            fill: this.color,
            align: 'center',
            lineJoin: 'round',
            stroke: 'black',
            strokeThickness: 3 * 2,
            wordWrap: true,
            wordWrapWidth: this.state.blok.size.x * Global.NATIVE_BLOCK_SIZE * 2
        });
        this.pixiText.width = Math.round(this.pixiText.width / 2) * 2 * 0.5;
        this.pixiText.height = Math.round(this.pixiText.height / 2) * 2 * 0.5;
        this.pixiText.roundPixels = true;
        this.pixiText.anchor.set(0.5);

        this.pixiContainer.addChild(this.pixiText);
        // this.pixiContainer.scale.x = 1 / scale;
        // this.pixiContainer.scale.y = 1 / scale;

        this.state.getParentPixiContainer().addChild(this.pixiContainer);
    }

    onUpdateVisuals() {
        if (!this._hasBody) {
            // If we have no physics presence.
        }
    }

    onDestroyVisuals() {
        this.pixiContainer.destroy();
        this.pixiContainer = null;
        this.pixiText.destroy();
        this.pixiText = null;
    }
}

Text.serializeableFields = {
    text: String,
    color: Number,
    size: Number
};
